import type { Author } from "@brookbush/types";

import Image from "next/image";

const AuthorCard = ({ author }: { author: Author }) => {
	return (
		<div className="flex items-center gap-2.5">
			<div className="relative h-10 w-10 shrink-0 overflow-hidden rounded-full border sm:h-11 sm:w-11">
				{author.thumbnail?.url ? (
					<Image
						fill
						alt={author.thumbnail.alt || author.fullName}
						src={author.thumbnail.url}
						className="object-cover"
					/>
				) : null}
			</div>

			<div className="flex flex-col gap-1">
				<p className="flex items-center gap-1 font-medium text-base">
					{author.fullName}
				</p>
				<p className="text-sm tracking-tight">{author.honorific}</p>
			</div>
		</div>
	);
};

export default AuthorCard;
